import { render, staticRenderFns } from "./RSNavigationElement.vue?vue&type=template&id=8d2ad0f8&scoped=true&"
import script from "./RSNavigationElement.vue?vue&type=script&lang=js&"
export * from "./RSNavigationElement.vue?vue&type=script&lang=js&"
import style0 from "./RSNavigationElement.vue?vue&type=style&index=0&id=8d2ad0f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2ad0f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d2ad0f8')) {
      api.createRecord('8d2ad0f8', component.options)
    } else {
      api.reload('8d2ad0f8', component.options)
    }
    module.hot.accept("./RSNavigationElement.vue?vue&type=template&id=8d2ad0f8&scoped=true&", function () {
      api.rerender('8d2ad0f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/repository-selector/RSNavigationElement.vue"
export default component.exports